import s3Service from './s3Service';
import config from '../config';

/**
 * Knowledge Base Service
 * Handles KB file operations (delete, update tags)
 */
class KnowledgeBaseService {
  /**
   * Delete KB files for a recording
   * @param {string} recordingKey - Full S3 key of the .webm recording
   */
  async deleteKBFiles(recordingKey) {
    try {
      const userId = recordingKey.split('/')[0];
      const filename = recordingKey.split('/').pop();
      
      // KB files to delete: .json, .md, and their .metadata.json files
      const kbExtensions = ['.json', '.md'];
      const filesToDelete = [];
      
      for (const ext of kbExtensions) {
        const kbFilename = filename.replace('.webm', ext);
        const kbKey = `${userId}/${kbFilename}`;
        const kbMetadataKey = `${kbKey}.metadata.json`;
        
        filesToDelete.push(kbKey, kbMetadataKey);
      }
      
      // Delete all KB files
      const success = await s3Service.deleteObjects(config.KBBucket, filesToDelete);
      
      if (success) {
        console.log(`Deleted KB files for: ${recordingKey}`);
      }
      
      return success;
    } catch (err) {
      console.error('Error deleting KB files:', err);
      return false;
    }
  }

  /**
   * Update KB file tags with new recording path
   * @param {string} oldRecordingKey - Old recording S3 key
   * @param {string} newRecordingKey - New recording S3 key
   */
  async updateKBFileTags(oldRecordingKey, newRecordingKey) {
    try {
      const userId = oldRecordingKey.split('/')[0];
      const filename = oldRecordingKey.split('/').pop();
      
      // KB files to update: .json and .md
      const kbExtensions = ['.json', '.md'];
      const updatePromises = [];
      
      for (const ext of kbExtensions) {
        const kbFilename = filename.replace('.webm', ext);
        const kbKey = `${userId}/${kbFilename}`;
        
        updatePromises.push(
          s3Service.updateTags(config.KBBucket, kbKey, {
            'recordings-file-key': newRecordingKey
          })
        );
      }
      
      const results = await Promise.all(updatePromises);
      const success = results.every(r => r === true);
      
      if (success) {
        console.log(`Updated KB tags: ${oldRecordingKey} -> ${newRecordingKey}`);
      }
      
      return success;
    } catch (err) {
      console.error('Error updating KB file tags:', err);
      return false;
    }
  }
}

// Export singleton instance
export default new KnowledgeBaseService();
